import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const validationSchema = () =>
  createValidationSchema({
    from: commonValidationSchemas.date({ required: true }),
    to: commonValidationSchemas.date({ required: true }),
    inactiveAdherenceCohorts: commonValidationSchemas.array(
      commonValidationSchemas.string(),
      { min: 1, required: true },
    ),
  });
